module.exports = __webpack_public_path__ + "static/coffee-828f61ebf6c355fbeb8f840faad5a698.jpg";